import {Pipe, PipeTransform} from '@angular/core';
import {ReportExtensions} from '@spa/api';
import {Helper} from '../classes';
import {Language} from '../language';
import {LanguageService} from '../language.service';

@Pipe({
	name: 'formatCurrencyDown'
})
export class FormatAvailableFundsPipe implements PipeTransform {
	constructor(private languageService: LanguageService) {
	}

	transform(value: number, currency: string, useIso?: boolean): string {
		let result = ReportExtensions.toDecimalString(
			value,
			4,
			4,
			false);

		if (this.languageService.getCurrentLanguage() === Language.Bulgarian) {
			result = result.replace(/,/g, ' ');
			result = result.replace('.', ',');
		}

		const sign = useIso
			? currency?.toUpperCase()
			: Helper.getCurrencySign(currency);

		if (result) {
			result = result.slice(0, -2);
		}

		if (sign) {
			if (useIso) {
				return `${sign} ${result}`;
			}

			return `${sign}${result}`;
		}

		return result;
	}
}
